export default {
  setSchedulePageData: (state, value) => {
    state.schedulePageData = value
  },

  setSchedulingFromBE: (state, value) => {
    switch (value.booking_type) {
      case 'regular':
        value.booking_type = 'einmalig'
        break

      case 'one-time':
        value.booking_type = 'regelmäßig'
        break
      default:
        break
    }

    state.scheduleFromBE = value
  },
}
